<template>
  <div class="row mb-2">
    <h5>Situação de Avaliação: {{projeto.avaliacao?.situacao_avaliacao_resumo}}</h5>
    <span v-if="projeto.avaliacao?.avaliacao_resumo.observacoes">{{projeto.avaliacao?.avaliacao_resumo.observacoes}}</span>
  </div>
  <div class="row">
    <div class="col-6">
      <form-group label="Avaliador Atual">
        <input
          class="form-control mb-2"
          type="text"
          placeholder="Avaliador"
          v-model="model.avaliador"
          maxlength="120"
          disabled
        />
      </form-group>
    </div>
    <div class="col-6">
      <form-group label="Novo Avaliador" required>
        <select class="form-select" ref="select2" @change="clearErrors('novo_avaliador')" v-model="model.novo_avaliador" data-control="select2" v-select2 data-placeholder="Selecione uma opção">
          <option></option>
          <option v-for="avaliador in avaliadores" :value="avaliador.id" :key="avaliador.id">{{avaliador.name}} ({{avaliador.projetos}})</option>
        </select>
        <span class="text-danger" v-if="errors.novo_avaliador">Selecione um novo avaliador</span>
        <span class="text-muted" v-else>O número em () é a quantidade de resumos a avaliar</span>
      </form-group>
    </div>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";
import {success} from "../../Settings/toastr";

export default {
  props: ['projeto', 'avaliadores'],

  components: {
    FormGroup,
    FormBody
  },
  data: _ => ({
    model: {
      projeto: null,
      avaliador: null,
      avaliador_id: null,
      novo_avaliador: null
    },
    errors: {
      novo_avaliador: false,
    },
    loading: false,
  }),

  created() {
    this.model.projeto = this.projeto.id
    this.model.avaliador = this.projeto.avaliadores[0].name
    this.model.avaliador_id = this.projeto.avaliadores[0].id

    this.emitter.on('click-save', function () {
      if (!this.model.novo_avaliador) {
        this.errors.novo_avaliador = true
        return
      }

      this.emitter.emit('loading-modal', true)
      axios.post(this.route('app.avaliadores.json.altera_avaliador'), this.model).then(result => {
        if (result.data) {
          success('Avaliador do projeto alterado com sucesso!')
          setTimeout( () => {
            window.location.reload()
          }, 2000)
        }
      })
    }.bind(this))
  },

  mounted() {
    $(this.$refs.select2).select2({
      dropdownParent: '#appModal'
    })
  },
  methods: {
    async submit() {
      this.loading = true
      let route = 'app.alunos.json.update';

      if (this.cadastro) {
        route = 'app.alunos.json.store'
      }

      if (this.form.isDirty || this.cadastro) {
        await axios.post(this.route(route), this.form).then(response => {
          this.$parent.adicionaAluno(response.data)
          this.closeModal()
        }).catch(error => {
          this.loading = false

          Object.entries(error.response.data.errors).forEach(([key, value]) => {
            this.form.setError(key, `${value}`)
          })
        })
      } else {
        this.$parent.adicionaAluno(this.aluno)
        this.resetForm()
      }
    },

    clearErrors(index) {
      this.errors[index] = false
    }
  },
}
</script>
